// src/utils/loaderEvents.js
import mitt from 'mitt';

const emitter = mitt();

export const LOADER_EVENTS = {
  START: 'start-loading',
  STOP: 'stop-loading',
};

export default emitter;
